export default __webpack_public_path__ + "static/media/popAd2.c9802ff5.gif";